import { CommonModule } from '@angular/common';
import {
  Component,
  effect,
  inject,
  input,
  OnInit,
  signal,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ProjectIdeaCeationResponse } from '@app/models/project-setup.models';
import { ProjectSetupService } from '@app/services/project-setup/project-setup.service';
import { GenericProjectStore } from '@app/stores/projects/generic-project.store';
import { CardComponent } from '@app/ui-components/card/card.component';
import { DisplayFieldComponent } from '@app/ui-components/display-field/display-field.component';
import { InfoLabelComponent } from '@app/ui-components/info-label/info-label.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-base-data-step',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CardComponent,
    TranslateModule,
    InfoLabelComponent,
    DisplayFieldComponent,
  ],
  templateUrl: './base-data-step.component.html',
  styleUrl: './base-data-step.component.scss',
})
export class BaseDataStepComponent implements OnInit {
  public projectId = input.required<string>();

  protected translateKey = 'projectWizard.basicDataForm.';

  protected baseData = signal<ProjectIdeaCeationResponse | undefined>(
    undefined
  );

  protected genericStore = inject(GenericProjectStore);

  protected projectFoundingTranslationKey = signal<string | null>(null);

  constructor(private service: ProjectSetupService) {
    effect(() => console.log(this.baseData()));
  }

  ngOnInit(): void {
    this.service.getProjectBaseData(this.projectId()).subscribe((response) => {
      this.baseData.set(response);
      const foundingMode = response?.foundingMode;
      const entities = this.genericStore.projectFoundingEntities?.() ?? [];
      const entity =
        foundingMode != null
          ? entities.find((e) => e.id === foundingMode)
          : entities[0];
      this.projectFoundingTranslationKey.set(
        entity ? `generic.projectFounding.${entity.name}` : null
      );
    });
  }
}
